import { appConfig } from '../../config';
import {
    jsonHeaderAuth,
    refreshAuthLogic
} from '../fetchTools';
import axios from 'axios';


export const getDataDiriByStatus = async () => {
    const url = `${appConfig.BASE_API}/requestRO/readbystatus/1.0`;
    const result = await axios.get(url, jsonHeaderAuth())
        .then(res => {
            // console.log('getDataDiriByStatus', res.data)
            return res.data
        })
        .catch(error => {
            // console.log('error', error)
            return null;
        })
    return result
};

export const updateDataDiriById = async (payload) => {

    try {
        const res = await axios.post(`${appConfig.BASE_API}/user/update/${localStorage.getItem('id')}`, payload, {
            headers: jsonHeaderAuth(),
            mode: 'cors'
        })

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const getDataDiri = async () => {
    try {
        const res = await axios.get(`${appConfig.BASE_API}/user/datadiri`, jsonHeaderAuth())
        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}

export const updateWhatsapp = async (payload) => {

    try {
        const res = await axios.post(`${appConfig.BASE_API}/user/updateWhatsapp`, payload, {
            headers: jsonHeaderAuth(),
            mode: 'cors'
        })

        return {status: res.status, data: res.data}
    } catch (error) {
        return { status: error.code, message: error.message }
    }
}